export default {"src":"/login-app/[GIT_HASH]/_next/static/media/schema.89d8f8f4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};